import { useCallback, useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { getNotificacoesVistas, listarIdsNotificacoes } from '../utils/notificacoes';

/**
 * Quantos avisos o usuário ainda não abriu na página de Notificações.
 * Abrir /notificacoes zera o badge na hora; os IDs entram no storage quando a
 * lista carrega, para o número não voltar ao sair da tela.
 */
export default function useNotificacoesNaoLidas(logado) {
  const { pathname } = useLocation();
  const [naoLidas, setNaoLidas] = useState(0);

  const recalcular = useCallback(async () => {
    if (!logado || !localStorage.getItem('token')) {
      setNaoLidas(0);
      return;
    }
    if (pathname === '/notificacoes') {
      setNaoLidas(0);
      return;
    }
    try {
      const ids = await listarIdsNotificacoes();
      const vistas = getNotificacoesVistas();
      setNaoLidas(ids.filter((id) => !vistas.includes(id)).length);
    } catch {
      /* badge não bloqueia o app */
    }
  }, [logado, pathname]);

  useEffect(() => {
    recalcular();
    window.addEventListener('notificacoes-atualizadas', recalcular);
    return () => window.removeEventListener('notificacoes-atualizadas', recalcular);
  }, [recalcular]);

  return naoLidas;
}
